import {type ElementType, type MouseEvent, type ReactNode, type Ref} from "react";
import classNames from "classnames";

import {svgIconWrapper} from "./SvgIconWrapper.module.css";

export type WrapperType = "circle" | "square";

interface IProps {
    children: ReactNode;
    wrapperColor: string;
    wrapperSize: string;
    wrapperType?: WrapperType;
    className?: string;
    onClick?: (event: MouseEvent) => void;
    as?: ElementType;
    "data-testid"?: string;
    ref?: Ref<HTMLDivElement>;
}

export const SvgIconWrapper = (props: IProps) => {
    const {ref, children, wrapperColor, wrapperSize, wrapperType = "circle", className, onClick, "data-testid": dataTestId} = props;

    const borderRadius = wrapperType === "circle" ? "50%" : "0%";
    const wrapperSizeStyle = {minWidth: `${wrapperSize}rem`, width: `${wrapperSize}rem`, height: `${wrapperSize}rem`};
    const wrapperColorStyle = {backgroundColor: wrapperColor};
    const wrapperStyle = {borderRadius, ...wrapperSizeStyle, ...wrapperColorStyle};
    const svgIconWrapperCN = classNames(svgIconWrapper, className);

    return (
        <div style={wrapperStyle} className={svgIconWrapperCN} onClick={onClick} ref={ref} data-testid={dataTestId}>
            {children}
        </div>
    );
};
